module.exports = __webpack_public_path__ + "static/media/img_features_01.ac976ed4.jpg";